/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { getCspNonce } from 'src/nonce';
const nonce = getCspNonce();
if (nonce && nonce !== '__CSP_NONCE__') {
    __webpack_nonce__ = nonce;
}
import('./bootstrap');
